import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=853e0aa0&scoped=true"
import script from "./UserDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./UserDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserDeleteDialog.vue?vue&type=style&index=0&id=853e0aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e0aa0",
  null
  
)

export default component.exports